"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "KoraChat", {
  enumerable: true,
  get: function () {
    return _KoraChat.KoraChat;
  }
});
var _KoraChat = require("./KoraChat");